export default function HomeSmallIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M14.7557 8.53248L10.5891 4.13254C10.4328 3.96763 10.2209 3.875 10 3.875C9.77908 3.875 9.5672 3.96763 9.41094 4.13254L5.24428 8.53248C5.16652 8.61398 5.10488 8.711 5.06294 8.81788C5.02101 8.92476 4.99962 9.03938 5.00001 9.15507V14.435C5.00001 14.5517 5.0439 14.6636 5.12204 14.7461C5.20018 14.8286 5.30616 14.875 5.41667 14.875H8.75C8.86051 14.875 8.96649 14.8286 9.04463 14.7461C9.12277 14.6636 9.16667 14.5517 9.16667 14.435V11.355H10.8333V14.435C10.8333 14.5517 10.8772 14.6636 10.9554 14.7461C11.0335 14.8286 11.1395 14.875 11.25 14.875H14.5833C14.6938 14.875 14.7998 14.8286 14.878 14.7461C14.9561 14.6636 15 14.5517 15 14.435V9.15507C15.0004 9.03938 14.979 8.92476 14.9371 8.81788C14.8951 8.711 14.8335 8.61398 14.7557 8.53248ZM14.1667 13.995H11.6667V10.9151C11.6667 10.7984 11.6228 10.6864 11.5446 10.6039C11.4665 10.5214 11.3605 10.4751 11.25 10.4751H8.75C8.63949 10.4751 8.53351 10.5214 8.45537 10.6039C8.37723 10.6864 8.33334 10.7984 8.33334 10.9151V13.995H5.83334V9.15507L10 4.75513L14.1667 9.15507V13.995Z"
        fill="currentColor"
      />
    </svg>
  );
}
